var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-3"},[_c('hb-notification',{attrs:{"type":_vm.type,"notDismissable":_vm.notDismissable},on:{"close":function($event){return _vm.$emit('resetStatus')}}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }